import { useCarts, useCartsDispatch } from '../contexts/CartContext';

const TotalPrice = () => {
    const cart = useCarts();
    const tt = cart;
    // Calculate total price
    const totalPrice = tt.reduce((sum, item) => sum + item.price * item.quantity, 0);

    // function currencyFormat(num) {
    //   return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '1,') + '฿'
    // };

    function numberWithCommas (nStr) {
      nStr = nStr.toFixed(2) + '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        x = x1 + x2;
        if(x.substr(0,1) === '.'){
            x = '0' + x;
        }
        return x + '฿';
    };
    // Output result
    // console.log(`Total Price: $${totalPrice.toFixed(2)}`);

  return (
    <p>
       {numberWithCommas(totalPrice)}
    </p>
  )
}

export default TotalPrice